import ninegrid from "../index.js";

export class ngTableManager
{
	#owner;
	
	constructor(owner) {
		this.#owner = owner;
		
		this.___init = () => {
			for (var s in this) {		// 함수 복사
				if (this[s] instanceof Function) this.#owner[s] = this[s].bind(this.#owner);
			}
		};
		
		this.___getColumnInfos = (col) => {
			var arr = [];
			$(`[data-col=${col}]`, this.#owner.template).each((i,el) => {
				if (el.dataset && el.dataset.bind) {
					arr.push({
						colnm	: el.dataset.bind,
						font	: $(el).css("font"),
					});
				}
			});
			return arr;
		};
		
		this.___getBindCols = (colnm) => {
	
			var arr = [];
			$(`[data-bind=${colnm}]`, this.#owner.template).each((i,el) => {
				arr.push(parseInt(el.dataset.col));
			});
			
			return arr;
		}
		
		this.getBand = (col) => {
			const target = $(`.col-indicator[data-col=${col}]`, this.#owner.body);
	
			if (target.closest(".ng-container-body").length > 0) {
				return ninegrid.BAND.BODY;
			}
			else if (target.closest(".ng-container-left").length > 0) {
				return ninegrid.BAND.LEFT;
			}
			else if (target.closest(".ng-container-right").length > 0) {
				return ninegrid.BAND.RIGHT;
			}
		};
		
		this.setColumnWidth = (col, w) => {
			
			w = parseInt(w);
			
			const band = this.getBand(col);

			this.#owner.body.querySelector(`colgroup [data-col="${col}"]:not(.cdummy)`).setAttribute("width", w);
			
			if (band != ninegrid.BAND.BODY) {
				var w = 0;
				$(`.ng-container-${band} col`, this.#owner.body).each((i,el) => { w += parseInt(el.getAttribute("width")); });
				$(`.ng-container-${band}`, this.#owner.body).css({ "width": w, "min-width"	: w, });
			}
			
			// h_scrollbar 처리
		};
	
		this.getExprFunc = (col, colnm) => {
			const cell = ninegrid.j.querySelectorAll(colnm ? `[data-col="${col}"][data-bind="${colnm}"]` : `[data-col="${col}"]`, this.#owner.tmpl).elem();
			const expr = cell ? cell.getAttribute("data-expr") : null;
			
			return (expr) ? this.#owner.exprFunction(expr) : null;
		};
		
		
		
		this.setColumnWidthFit = (col, minWidth, async) => {
	
			if (async == undefined) async = true;
		
			if (async) {
				ninegrid.j.querySelectorAll(this.#owner).addClass("loading");
				
				setTimeout(() => {
					var w = this.#getColumnTextWidth(col);
					//if (w != 0) this.setColumnWidth(col, minWidth ? Math.max(w, minWidth) : w);
					this.setColumnWidth(col, minWidth ? Math.max(w, minWidth) : w);
		
					ninegrid.j.querySelectorAll(this.#owner).removeClass("loading");
				});
			}
			else {
				var w = this.#getColumnTextWidth(col);
				//if (w != 0) this.setColumnWidth(col, minWidth ? Math.max(w, minWidth) : w);
				this.setColumnWidth(col, minWidth ? Math.max(w, minWidth) : w);
			}
		};

		this.insertCol = (col, xml, isFirst) => {
	
			if (!['string','number'].includes(typeof col)) throw `invalid argument : "${col}"`;
	
			if (isFirst == undefined) isFirst = true;
			
			if (typeof col === 'string') {
				var cols = this.___getBindCols(col);
				if (cols.length <= 0) throw `invalid argument : "${col}"`;
				col = cols[0];
			}
		
			var insertColIndicator = (col) => {
				var toTH = $(`.col-indicator[data-col=${col}]`, this.#owner.body);
				if (toTH.length <= 0) throw 'missing col';
	
				$(xml).find('col').each((i,el) => {
					var w = el.getAttribute("width") || 100;
					const th = document.createElement('th');
					th.setAttribute("scope", "col");
					
					ninegrid.j.querySelectorAll(th).addClass("col-indicator");
					
					$(th).html('<div></div>').insertBefore(toTH).css({ "width" : w, "min-width" : w, });
				});
	
				return toTH;
			};
			
			var insertedTH = insertColIndicator(col);
			
			
			var insertCell = (group, col) => {
				
				var fromTRs	= $(xml).find(`${group} tr`);
				var toTRs	= $(`${group} tr`, insertedTH.closest('table')).not(".col-indicator-rowgroup").not(".nodata");
				var colSpan	= 0;
				$("th,td", fromTRs.eq(0)).each((i,el) => { colSpan += el.colSpan; });

				
				var rowIndex = 0;
				toTRs.each((i,toTR) => {
					var toTD = $(toTR).find(`[data-col=${col}]`);
					if (toTD.length > 0) {
						$(fromTRs).eq(rowIndex).find('th,td').each((j,fromTD) => {
							toTR.insertBefore(fromTD, toTD[0]);
						});
						
						rowIndex ++;
					}
					else {
						for (var i = col - 1; i >= 0; i--) {
							var toTD = $(`[data-col=${i}]`, toTR);
							if (toTD.length > 0) {
								toTD[0].colSpan += colSpan;//fromTD.colSpan;
								break;
							}
						}
					}
				});
			}
			
			var insertBodyCell = (group, col) => {
				
				var fromTRs	= $(xml).find(`${group} tr`);
				var toTRs	= $(`${group} tr`, insertedTH.closest('table')).not(".col-indicator-rowgroup").not(".nodata");
				var colSpan	= 0;
				$("th,td", fromTRs.eq(0)).each((i,el) => { colSpan += el.colSpan; });


				
				var rowIndex = 0;
				toTRs.each((i,toTR) => {

					
					var toTD = $(toTR).find(`[data-col=${col}]`);
					if (toTD.length > 0) {

						
						$(fromTRs).eq(parseInt(toTR.sectionRowIndex % this.#owner.template.length)).find('th,td').each((j,fromTD) => {

							toTR.insertBefore($(fromTD).clone()[0], toTD[0]);
						});
						
						rowIndex ++;
					}
					else {
						for (var i = col - 1; i >= 0; i--) {
							var toTD = $(`[data-col=${i}]`, toTR);
							if (toTD.length > 0) {
								toTD[0].colSpan += colSpan;//fromTD.colSpan;
								break;
							}
						}
					}
				});
			}
			
			var insertTemplateCell = (group, col) => {
				
				var fromTRs	= $(xml).find(`${group} tr`);
				var toTRs	= this.#owner.template;//$(`${group} tr`, insertedTH.closest('table')).not(".col-indicator-rowgroup").not(".nodata");
				var colSpan	= 0;
				$("th,td", fromTRs.eq(0)).each((i,el) => { colSpan += el.colSpan; });
	
				var rowIndex = 0;
				toTRs.each((i,toTR) => {
					var toTD = $(toTR).find(`[data-col=${col}]`);
	
					if (toTD.length > 0) {

					
						$(fromTRs).eq(rowIndex).find('th,td').each((j,fromTD) => {
							toTR.insertBefore(fromTD, toTD[0]);
						});
						
						rowIndex ++;
					}
					else {
						for (var i = col - 1; i >= 0; i--) {
							var toTD = $(`[data-col=${i}]`, toTR);
							if (toTD.length > 0) {
								toTD[0].colSpan += colSpan;//fromTD.colSpan;
								break;
							}
						}
					}
				});
			};
			
			insertCell("thead", col);
			insertCell("tfoot", col);
			insertBodyCell("tbody", col);
			
			insertTemplateCell("tbody", col);
	
			this.#owner.resetTemplate();
			
			this.#owner.dataManager.viewRecords.touch();
		}
		
		
		
		
		this.___init();
	};
	
	getDisplayValue3 = (matrixRow, col) => {
		const row = parseInt(matrixRow / this.#owner.template.length);
		const tr = this.#owner.template[matrixRow % this.#owner.template.length];
		const cell = tr.querySelector(`[data-col="${col}"]`);
		
		if (!cell || !cell.dataset) return "";
		
		if (cell.dataset.expr) {
			return this.#owner.exprFunction(cell.dataset.expr).call(this, this.#owner.data.get(row), row);
		}
		else if (cell.dataset.bind) {
			return this.#owner.data.get(row, cell.dataset.bind);
		}
	};

	getDisplayValue2 = (row, col, colnm, exprFunc, comp) => {
		var rowData = this.#owner.data.get(row);
		return this.getDisplayValue(rowData, row, colnm, exprFunc, comp);
	};

	getDisplayValue = (rowData, row, colnm, exprFunc, comp) => {

		var o = { "code" : 0, "value" : ""};
		
		if (exprFunc) {
			o.value = exprFunc(rowData, row);
		}
		else if (comp == null) {
			o.value = rowData[colnm];
		}
		else {
			switch (comp.tagName) {
			case "NG-COMBO":
				var multi			= comp.getAttribute('multi') == "true";
				var multiSeparator	= comp.getAttribute("multi-separator")	|| ",";
				var key				= comp.getAttribute('key')				|| 'key';
				var value			= comp.getAttribute('value')			|| key;
				
				var dataSource = comp.dataSource;
				
				var data2 = [];
				
				if (multi) {
					rowData[colnm].split(multiSeparator).forEach(s => {
						var idx = dataSource.findIndex(m => { return s == m[key]; });
						if (idx >= 0) {
							data2.push(dataSource[idx][value]);
						}
						else {
							o.code = -1;		// invalid
						}
					});
				}
				else {
					var idx = dataSource.findIndex(m => { return rowData[colnm] == m[key]; });
					if (idx >= 0) {
						data2.push(dataSource[idx][value]);
					}
					else {
						o.code = -1;		// invalid
					}
				}
				
				o.value = data2.length > 0 ? data2.join(multiSeparator) : rowData[colnm];
				break;
				
			case "NG-CHECKBOX":
				o.value = rowData[colnm];
				if (o.value != null && o.value != "") {
					o.code = comp.dataSource.map(m => { return m["value"]; }).includes(o.value) ? 0 : -1;
				}
				break;
			
			case "NG-RADIO":
				o.value = rowData[colnm];
				if (o.value != null && o.value != "" && !ninegrid.isNull(comp.dataSource)) {
					o.code = comp.dataSource.map(m => { return m[comp.getAttribute("key") || "key"]; }).includes(o.value) ? 0 : -1;
				}
				break;
				
			default:
				o.value = rowData[colnm];
				break;
			}
		}
		
		return o;
	};
	
	setRowHeightFitAll = (tds) => {
		this.#setRowHeightFit(null, tds)
	}
	
	#setRowHeightFit = (matrixRow, tds) => {
		
		if (!tds) {
			tds = [];
			for (var i = 0; i < this.#owner.template.length; i++) {
				tds.push($("th,td", this.#owner.template.eq(i)));
			}
		}
		/**
		var tds = [];
		for (var i = 0; i < this.#owner.template.length; i++) {
			tds.push($(arr.join(","), this.#owner.template.eq(i)));
		}*/

		var defaultFont = $(this.#owner).css("font");
		var fonts = [];
		for (var i = 0; i < tds.length; i++) {
			var f = []
			tds[i].each((j,el) => {
				f.push($(el).css("font") || defaultFont);
			});
			fonts.push(f);
		}

		if (matrixRow == null) {
			ninegrid.j.querySelectorAll(this.#owner).addClass("loading");
			
			setTimeout(() => {
				for (var i = 0; i < this.#owner.data.count(); i++) {
					for (var j = 0; j < this.#owner.template.length; j++) {
						var matrixRow = i * this.#owner.template.length + j;
						var index = parseInt(matrixRow % this.#owner.template.length);
						var minHeight = 0;
						$(this.#owner.template).eq(matrixRow % this.#owner.template.length).each((i,tr) => {
							minHeight = $(tr).height() || 32;
						});
						
						var h = (tds[index].length == 0) ? minHeight : this.#getColumnTextHeight(matrixRow, tds[index], fonts[index]) + 12;
						this.#owner.matrix.setHeight(matrixRow, minHeight ? Math.max(h, minHeight) : h);
					}
				}

				this.#owner.view.redraw();
				
				ninegrid.j.querySelectorAll(this.#owner).removeClass("loading");
			});
		}
		else {
			var minHeight = 0;
			$(this.#owner.template).eq(matrixRow % this.#owner.template.length).each((i,tr) => {
				minHeight = $(tr).height() || 32;
			});
			
			var index = parseInt(matrixRow % this.#owner.template.length);
			var h = (tds[index].length == 0) ? minHeight : this.#getColumnTextHeight(matrixRow, tds[index], fonts[index]) + 12;
			this.#owner.matrix.setHeight(matrixRow, minHeight ? Math.max(h, minHeight) : h);
			
			this.#owner.view.redraw();
		}
		
		
	}
	
	#getColumnTextHeight = (matrixRow, elements, fonts) => {

		var row = parseInt(matrixRow / this.#owner.template.length);
		var h = 0;
		var rowData = this.#owner.data.getRow(row);

		elements.each((i, el) => {
			const bind		= el.dataset.bind;
			const COL_IDX	= this.#owner.fields.indexOf(bind);
			const v			= String(rowData.v[COL_IDX]);
			
			if (bind && v.includes("\n")) {
				h = Math.max(h, ninegrid.measureTextSize(v, fonts[i]).height);
			}
		});
		
		return h;
	};
	
	#getColumnTextWidth = (col) => {

		var w = 0;
		
		$(`[data-col=${col}]`, this.#owner.template).each((i,cell) => {
		//this.#owner.tmpl.forEach(tr => {
			//console.log(tr);
			//const cell = tr.querySelector(`[data-col="${col}]"`);
			//const cell = ninegrid.j.querySelectorAll(`[data-col="${col}]"`, this.#owner.tmpl).elem();
			//console.log(col, cell)
			
			
			var font = $(cell).css("font");
			if (!font) font = $(this.#owner).css("font");

			var exprFunc = this.getExprFunc(col, cell.dataset.bind);
			var comp = cell.querySelector("ng-combo");
			
			var row = 0;
			for (var data of this.#owner.data.getValidData()) {
				
				if (comp) comp.owner = this.#owner;
				var v = this.getDisplayValue2(row++, col, cell.dataset.bind, exprFunc, comp).value;
				if (!v) continue;


				w = Math.max(w, ninegrid.measureTextSize(v, font).width);// + (comp.length > 0 ? 40 : 0);
			}
		});

		
		w += $(`[data-col=${col}] ng-combo`, this.#owner.template).length > 0 ? 40 : 0;

		return w == 0 ? 0 : w + 8;
	};
}